"use client";

import { c as _c } from "react/compiler-runtime";
import * as stylex from "@stylexjs/stylex";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Dialog } from "./internal";
export function Commands(props) {
  const $ = _c(13);
  const {
    open: _open,
    onClose: _onClose
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      dialog: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = React.useState(t0);
  let t1;
  if ($[1] !== _onClose || $[2] !== state.dialog) {
    t1 = function open() {
      setState({
        dialog: (() => {
          if (!state.dialog) {
            const containerElement = document.createElement("div");
            document.body.appendChild(containerElement);
            const reactPortal = ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke" onClick={ev => {
              if (ev.target === ev.currentTarget) {
                _onClose();
              }
            }}><Dialog open={true} onClose={_onClose} /></div>, containerElement);
            return {
              containerElement,
              reactPortal
            };
          } else {
            return {
              containerElement: state.dialog.containerElement,
              reactPortal: ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke" onClick={ev_0 => {
                if (ev_0.target === ev_0.currentTarget) {
                  _onClose();
                }
              }}><Dialog open={true} onClose={_onClose} /></div>, state.dialog.containerElement)
            };
          }
        })()
      });
    };
    $[1] = _onClose;
    $[2] = state.dialog;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const open = t1;
  let t2;
  if ($[4] !== _open || $[5] !== state.dialog) {
    t2 = function close() {
      setState({
        dialog: (() => {
          if (state.dialog) {
            return {
              containerElement: state.dialog.containerElement,
              reactPortal: ReactDOM.createPortal(<div className="xixxii4 x10a8y8t x78zum5 xoz0ns6 x1cy8zhl xl56j7k x1tv4xqk x1p7i66b xdvd4st x1746jcd x1j61zf2 x1wqqpke"><Dialog onDispose={() => {
                  setState({
                    dialog: (() => {
                      if (!_open && state.dialog) {
                        document.body.removeChild(state.dialog.containerElement);
                        return null;
                      } else {
                        return state.dialog;
                      }
                    })()
                  });
                }} /></div>, state.dialog.containerElement)
            };
          } else {
            return state.dialog;
          }
        })()
      });
    };
    $[4] = _open;
    $[5] = state.dialog;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const close = t2;
  let t3;
  if ($[7] !== _open || $[8] !== close || $[9] !== open) {
    t3 = () => {
      if (_open) {
        document.body.style.overflow = "hidden";
        open();
        return _temp;
      } else {
        close();
      }
    };
    $[7] = _open;
    $[8] = close;
    $[9] = open;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== _open) {
    t4 = [_open];
    $[11] = _open;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  React.useEffect(t3, t4);
  return state.dialog?.reactPortal ?? null;
}
function _temp() {
  document.body.style.overflow = "";
}